const hasAnswer = (value) => (
  value !== undefined
  && value !== null
  && value !== ""
  && (!Array.isArray(value) || value.length > 0)
);

const requiredField = (field) => (
  field?.required !== false
  && field?.is_required !== false
  && field?.validation?.required !== false
  && field?.validation_rules?.required !== false
);

/**
 * The common boundary may only be submitted once every required field in the
 * server's current step has a browser answer. This keeps a state-selection
 * transition from following up with `answer_common: {}` before the newly
 * rendered common Section can be completed.
 */
export const hasCompleteCommonBoundaryInput = (payload, session) => {
  const fields = (session?.step?.sections || []).flatMap(
    (section) => section?.fields || [],
  );
  if (!fields.length) return Object.keys(payload?.common || {}).length > 0;
  return fields.filter(requiredField).every((field) => (
    hasAnswer(payload?.common?.[String(field.source_id || field.id || "")])
  ));
};
